// 进货单
import * as React from 'react';
import * as ReactDOM from 'react-dom';

import '../../../components/common';
import '../../../components/shop/common';
import Toast from '../../../components/popup/toast';
import config from '../../../utils/config';
import request from '../../../utils/request';
import * as utils from '../../../utils/utils';

export default class Cart extends React.Component < {}, any > {
    private toastTimer: any;
    constructor(props: any) {
        super(props);
        this.state = {
            checkCart: false, // 全选购物车
            checkItemResult: [], // 选择单条数据结果
            checkStoreResult: [], // 选择店铺结果
            isEdit: false, // 编辑
            list: [], // 购物车数据列表
            toastText: '', // 提示文本
            toastVisible: false, // 提示框可视化
            isReading: true,
        };
    }
    public componentDidMount() {
        this.getData();
    }
    public render() {
        const state = this.state;
        return (
            <div>
        <div className="jhnav">
          <div className="jhnav-back" onClick={() => this.backAction()}><img src={require('../../../assets/images/backs.png')} /></div>
          <div className="jhd">进货单{state.list.length > 0 ? <span>({this.totalNum()})</span> : null}</div>
          <span className="rig_shai" onClick={() => this.editAction()}>{state.isEdit ? '完成' : '编辑'}</span>
        </div>
        {
          state.list.length === 0 ?
            <div className="empty">
              <span className="emptyImg" />
              <h2>进货单空空如也</h2>
              <p>赶紧挑一些中意的货品吧!</p>
              <a className="button-important" href="/m/">去首页逛逛</a>
            </div>
            :
            <div className="block">
              {
                state.list.map((v: any, k: number) => {
                  return (
                    v.shop ?
                    <div className="commodity_list_box" key={`cartItem${k}`}>
                      <div className="commodity_list">
                        <div className="tite_tim">
                          <em onClick={e => this.checkAll(k)} className={state.checkStoreResult[k] ? 'pitch_on' : ''} />
                          <span>{v.shop ? v.shop.shop_name : ''}</span>
                          <div className="clear" />
                        </div>
                        <ul className="commodity_list_term">
                          {
                            v.carts.map((cv: any, ck: number) => {
                              return (
                                  cv.goods && cv.skuPrice ?
                                    <li key={`cartGoods-${k}-${ck}`}>
                                      <em onClick={e => this.checkItem(k, ck)} className={state.checkItemResult[k][ck] ? 'pitch_on' : ''} />
                                      <img src={cv.goods.goods_img} onClick={() => this.jumpToDetail(cv.goods.goods_id, v.shop)} />
                                      <div className="div_center">
                                        <h4 onClick={() => this.jumpToDetail(cv.goods.goods_id, v.shop)}>{cv.goods.goods_name}</h4>
                                        <p className="now_value" onClick={() => this.jumpToDetail(cv.goods.goods_id, v.shop)}>
                                          <i>￥</i>
                                          {
                                            cv.skuPrice.price_type === 3 ?
                                              <b className="qu_su">面议</b>
                                              :
                                              <b className="qu_su">{cv.skuPrice.discount_price || cv.skuPrice.origin_price}</b>
                                          }
                                          {
                                            cv.skuPrice.price_type !== 3 ?
                                              <span>/{cv.goods.unit_customize}</span>
                                              : null
                                          }
                                        </p>
                                      </div>
                                      {
                                        (v.shop.status === 2 || cv.goods.is_deleted === 1) ?
                                          null
                                          : <div className="div_right">
                                            <i onClick={() => this.reduceAction(k, ck)}>-</i>
                                            <input type="text" value={cv.qty} className="zi" onChange={(e) => this.qtyAction(k, ck, e)} onBlur={e => this.asyncCalcNum(k, ck, state.list)} />
                                            <i onClick={() => this.plusAction(k, ck)}>+</i>
                                          </div>
                                      }
                                      {
                                        (v.shop.status === 2 || cv.goods.is_deleted === 1) ?
                                          <div className="cart-item-mark">
                                            商品已失效
                                      </div>
                                          : null
                                      }
                                    </li> : null
                                )
                            })
                          }
                        </ul>
                      </div>
                    </div>
                    : null
                  )
                })
              }
              <div className="cart_bottom_padding" />
              <div className="settle_box">
                <dl className="all_check select" onClick={() => this.checkCartAction()}>
                  <dt>
                    <span className={`${state.checkCart ? 'pitch_on' : ''}`}></span>
                    <b>全选</b></dt>
                </dl>
                {
                  state.isEdit ?
                    <a className="settle_btn" href="javascript:void(0);" onClick={() => this.removeAction()}>删除</a>
                    : <dl className="total_amount">
                      <dt>总计：
                              <p id="total_price">￥<b>{this.totalMoney()}</b></p>
                      </dt>
                      <dd>不含运费</dd>
                    </dl>
                }
                {
                  state.isEdit ? null : <a className="settle_btn" href="javascript:void(0);" onClick={() => this.settleAction()}>结算</a>
                }
              </div>
            </div>
        }
        <Toast text={this.state.toastText} visible={this.state.toastVisible} />
      </div>
        )
    }
    /**
     * [单个店铺全选]
     * @param number [索引]
     */
    private checkAll(index: number) {
        const checkStoreTemp = this.state.checkStoreResult;
        const checkItemTemp = [...this.state.checkItemResult];
        const checked: any = !checkStoreTemp[index];
        checkStoreTemp[index] = checked;
        if (checkItemTemp[index].length) {
            checkItemTemp[index].forEach((v: any, k: number) => {
                checkItemTemp[index][k] = checked;
            });
        }
        // 判断是否全选购物车
        const r = checkStoreTemp.every((v: any) => v);
        this.setState({ checkCart: r, checkStoreResult: checkStoreTemp, checkItemResult: checkItemTemp });
    }
    /**
     * [单条数据全选]
     * @param  pindex [店铺索引]
     * @param  index [店铺下数据索引]
     */
    private checkItem(pindex: number, index: number) {
        const checkStoreTemp = this.state.checkStoreResult;
        const checkItemTemp = this.state.checkItemResult;
        const checked: any = !checkItemTemp[pindex][index];
        checkItemTemp[pindex][index] = checked;
        let storeCheck: boolean;
        if (!checked) {
            storeCheck = false;
        } else {
            storeCheck = checkItemTemp[pindex].every((v: any) => v);
        }
        checkStoreTemp[pindex] = storeCheck;
        // 判断是否全选购物车
        const r = checkStoreTemp.every((v: any) => v);
        this.setState({ checkCart: r, checkStoreResult: checkStoreTemp, checkItemResult: checkItemTemp });
    }
    /**
     * [获取列表数据]
     */
    private async getData() {
        const r = await request({
            url: `${config.JAVAORDER}wiseshop/wap/cart/list`
        });
        if (r.code === 1) {
            const tempCheckStoreResult: boolean[] = [];
            const tempCheckItemResult: any[] = [];
            r.obj.forEach((v: any, k: number) => {
                tempCheckStoreResult.push(false);
                tempCheckItemResult[k] = [];
                v.carts.forEach((cv: any, ck: number) => {
                    tempCheckItemResult[k].push(false);
                });
            });
            this.setState({ checkItemResult: tempCheckItemResult, checkStoreResult: tempCheckStoreResult, list: r.obj });
        }
    }
    // 返回上一页
    private backAction() {
        window.history.back();
    }
    /**
     * [减少一个数量]
     * @param pindex [店铺索引]
     * @param index [店铺下数据索引]
     */
    private async reduceAction(pindex: number, index: number) {
        const r = this.state.list;
        if (r[pindex].carts[index].qty < 2) {
            r[pindex].carts[index].qty = 1;
            return;
        } else {
            r[pindex].carts[index].qty = utils.cal(r[pindex].carts[index].qty, 1).plus;
        }
        this.asyncCalcNum(pindex, index, r);
    }
    /**
     * [加上一个数量]
     * @param pindex [店铺索引]
     * @param index [店铺下数据索引]
     */
    private async plusAction(pindex: number, index: number) {
        const r = this.state.list;
        if (r[pindex].carts[index].qty >= r[pindex].carts[index].goods.stock) {
            r[pindex].carts[index].qty = r[pindex].carts[index].goods.stock;
            return;
        } else {
            r[pindex].carts[index].qty = utils.cal(r[pindex].carts[index].qty, 1).add;
        }
        this.asyncCalcNum(pindex, index, r);
    }
    /**
     * [编辑数量]
     * @param pindex [店铺索引]
     * @param index [店铺下数据索引]
     * @param e [事件]
     */
    private async qtyAction(pindex: number, index: number, e: any) {
        const value = e.target.value;
        const r = this.state.list;
        if (!isNaN(value) && value > 0) {
            if (value >= r[pindex].carts[index].goods.stock) {
                r[pindex].carts[index].qty = r[pindex].carts[index].goods.stock;
            } else {
                r[pindex].carts[index].qty = value;
            }
        } else if (value === '') {
            r[pindex].carts[index].qty = '';
        }
        this.setState({ list: r });
        // this.asyncCalcNum(pindex, index, r);
    }
    /**
     * [计算购物车所有产品数量]
     * @return 数量
     */
    private totalNum(): number {
        return this.state.list.reduce((total: number, v: any, pindex: number) => {
            return utils.cal(total, v.carts.reduce((total1: number, v1: any, index: number) => {
                return utils.cal(total1, v1.qty).add;
            }, 0)).add
        }, 0)
    }
    /**
     * [计算购物车总价格]
     * @return 价格
     */
    private totalMoney(): number {
        return this.state.list.reduce((total: number, v: any, pindex: number) => {
            return utils.cal(total, v.carts.reduce((total1: number, v1: any, index: number) => {
                let price = 0;
                if (v1.skuPrice) {
                    price = v1.skuPrice.price_type === 3 ? 0 : utils.cal(((v1.skuPrice.discount_price || v1.skuPrice.origin_price)), v1.qty).multi;
                }
                return utils.cal(total1, (this.state.checkItemResult[pindex][index] ? price : 0)).add;
            }, 0)).add;
        }, 0);
    }
    /**
     * [总类数量]
     * @return 总类数量
     */
    // private totalCount(): number {
    //   return this.state.list.reduce((total: number, v: any, pindex: number) => {
    //     return total + v.carts.reduce((total1: number, v1: any, index: number) => {
    //       return total1 + (this.state.checkItemResult[pindex][index] ? 1 : 0)
    //     }, 0)
    //   }, 0)
    // }
    /**
     * [异步计算购物车数量]
     * @param pindex [店铺索引]
     * @param index [店铺下数据索引]
     * @param list [更改数量后的列表]
     */
    private async asyncCalcNum(pindex: number, index: number, list: any) {
        this.setState({
            isReading: false,
        })

        const r = await request({
            data: {
                id: list[pindex].carts[index].id,
                qty: list[pindex].carts[index].qty
            },
            method: 'post',
            url: `${config.JAVAORDER}wiseshop/cart/modify`
        });

        this.setState({
            isReading: true,
        })
        if (r.code === 1) {
            list[pindex].carts[index] = r.obj;
            this.setState({ list });
        } else {
            list[pindex].carts[index].qty = 1;
            this.showToastAction(r.msg);
        }
    }
    /**
     * [是否可以结算]
     * @return 验证结果
     */
    private validateCart() {
        let pass = false;
        this.state.checkItemResult.forEach((v: any) => {
            v.forEach((v1: boolean) => {
                if (v1) {
                    pass = true;
                }
            });
        });
        return pass;
    }
    private async settleAction() {
        if (!this.state.isReading) {
            return this.showToastAction('商品数量错误，请重新发起结算');
            return;
        }

        if (!this.validateCart()) {
            return this.showToastAction('请选择要结算的商品');
        }
        const cartId: any[] = [];
        let tips = '';
        this.state.checkStoreResult.map((v: any, k: number) => {
            if (v && this.state.list[k].shop && this.state.list[k].shop.status === 2 && !tips) {
                tips = `第${k + 1}个店铺已关闭，无法购买该店铺的商品`;
            }
        });
        this.state.checkItemResult.map((v: any, k: number) => {
            v.forEach((v1: boolean, k1: number) => {
                if (v1 && this.state.list[k].shop) {
                    cartId.push(this.state.list[k].carts[k1].id);
                    if (this.state.list[k].carts[k1].goods.is_deleted === 1) {
                        if (!tips) {
                            tips = `第${k + 1}个店铺第${k1 + 1}个商品已经失效，无法购买`;
                        }
                    }
                }
            });
        });
        if (tips) {
            return this.showToastAction(tips);
        }
        const r2 = await request({
            data: {
                cartIds: cartId.join(',') || ''
            },
            url: `${config.JAVAORDER}wiseshop/wap/buyer/order/clear/view`
        });
        if (r2.code === 1) {
            window.location.href = `/m/order/?cartId=${cartId.join(',')}`;
        } else {
            this.showToastAction(r2.message);
        }
    }
    // 删除购物车
    private async removeAction() {
        if (!this.validateCart()) {
            return this.showToastAction('请选择要删除的商品');
        }
        const cartId: any[] = [];
        this.state.checkItemResult.map((v: any, k: number) => {
            v.forEach((v1: boolean, k1: number) => {
                if (v1) {
                    cartId.push(this.state.list[k].carts[k1].id);
                }
            });
        });
        const r = await request({
            data: {
                cartIds: cartId.join(',')
            },
            method: 'post',
            url: `${config.JAVAORDER}wiseshop/cart/delete`
        });
        if (r.code === 1) {
            window.location.reload();
        } else {
            this.showToastAction(r.messages);
        }
    }
    // 编辑
    private editAction() {
        if (this.state.isEdit) {
            const checkStoreTemp: boolean[] = [];
            const checkItemTemp: any[] = [];
            this.state.checkStoreResult.forEach((v: any, k: number) => {
                checkStoreTemp.push(false);
                checkItemTemp[k] = [];
                this.state.checkItemResult[k].forEach(() => {
                    checkItemTemp[k].push(false);
                });
            });
            this.setState({ checkCart: false, checkItemResult: checkItemTemp, checkStoreResult: checkStoreTemp });
        }
        this.setState({ isEdit: !this.state.isEdit });
    }
    // 隐藏提示框
    private hideToastAction() {
        if (this.toastTimer) {
            clearTimeout(this.toastTimer);
        }
        this.toastTimer = setTimeout(() => {
            this.setState({ toastText: '', toastVisible: false });
        }, 2000);
    }
    /**
     * [显示提示框]
     * @param  text [提示文本]
     */
    private showToastAction(text: string) {
        this.setState({ toastText: text, toastVisible: true });
        this.hideToastAction();
    }
    // 全选&取消整个购物车
    private checkCartAction() {
        // 取消全选
        const checkStoreTemp: boolean[] = [];
        const checkItemTemp: any[] = [];
        if (this.state.checkCart) {
            this.state.checkStoreResult.forEach((v: any, k: number) => {
                checkStoreTemp.push(false);
                checkItemTemp[k] = [];
                this.state.checkItemResult[k].forEach(() => {
                    checkItemTemp[k].push(false);
                });
            });
        } else {
            this.state.checkStoreResult.forEach((v: any, k: number) => {
                checkStoreTemp.push(true);
                checkItemTemp[k] = [];
                this.state.checkItemResult[k].forEach(() => {
                    checkItemTemp[k].push(true);
                });
            });
        }
        this.setState({ checkCart: !this.state.checkCart, checkItemResult: checkItemTemp, checkStoreResult: checkStoreTemp });
    }
    /**
     * [跳转到商品详情]
     * @param id 商品id
     * @param shop 商品对应店铺
     */
    private jumpToDetail(id: number, shop: any) {
        window.location.href = `https://${shop.shop_domain_wap}.${config.ENV === 'production' ? 'cn' : 'cn-stg'}.ibuychem.com/m/offer/?id=${id}`;
    }
}

ReactDOM.render(
    <Cart />,
    document.getElementById('root') as HTMLElement
);


// WEBPACK FOOTER //
// ./src/containers/shop/cart/index.tsx